import { useInfiniteQuery } from '@tanstack/react-query';
import { getManualPayouts, GetTransfersParams } from '../services/transferService';

const useGetManualPayouts = (params?: Omit<GetTransfersParams, 'status'>) => {
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    isLoading,
    status,
    isError,
    refetch,
    isPending,
  } = useInfiniteQuery({
    queryKey: ['manual-payouts', params],
    queryFn: async (args) => {
      const { pageParam } = args;
      return getManualPayouts({
        next_cursor: pageParam,
        ...params,
      });
    },
    initialPageParam: '',
    getNextPageParam: (lastPage) => lastPage?.next_cursor,
    select: (data) => data?.pages.flatMap((page) => page.transfers),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });

  return {
    data: Array.isArray(data) ? data.filter((item) => !!item) : data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
    isFetchingNextPage,
    isError,
    status,
    refetch,
    isPending,
  };
};

export default useGetManualPayouts;
